import { RealTimeAction } from '@/_core/fluxstore/types';
import { StorymapState } from '../../types';
import { useStorymapStore } from '../../useModule';
import { useSendCommand } from '@/_core/cqrs/use';
import { ChangeStorymapCardDefaultColors } from '../../../api/commands';

const { registerReducer, registerMiddleware } = useStorymapStore();

export class ChangeAcitivtyColor extends RealTimeAction<StorymapState> {
    public static ACTION_TYPE = 'ChangeAcitivtyColor';

    public constructor(public color: number) {
        super(ChangeAcitivtyColor.ACTION_TYPE);
    }
}

const middleware = async (state: StorymapState, action: ChangeAcitivtyColor): Promise<boolean> => {
    useSendCommand(action, {
        createCommand: () => new ChangeStorymapCardDefaultColors(state.id, action.color, state.taskColor, state.subtaskColor),
    });

    return true;
};

const reducer = (state: StorymapState, action: ChangeAcitivtyColor): void => {
    state.activityColor = action.color;
};

//@ts-ignore
registerMiddleware(ChangeAcitivtyColor.ACTION_TYPE, middleware);

//@ts-ignore
registerReducer(ChangeAcitivtyColor.ACTION_TYPE, reducer);
